import styles from 'styles/Footer.module.css';
import Logo from 'assets/images/header/logo_flex_w.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className={styles["footer"]}>
      <img src={Logo} className={styles["footer-img"]} alt="AREA CUP ロゴ"/>
      <div className={styles["footer-nav-container"]}>
        <div className={styles["footer-nav-row"]}>
          <Link to="/#news" className={styles["footer-nav"]}>THE LATEST</Link>
          <Link to="/#about" className={styles["footer-nav"]}>ABOUT</Link>
          <Link to="/#ranking" className={styles["footer-nav"]}>RANKING</Link>
        </div>

        <div className={styles["footer-nav-row"]}>
          <Link to="/#schedule" className={styles["footer-nav"]}>SCHEDULE</Link>
          <Link to="/guideline" className={styles["footer-nav"]}>GUIDELINE</Link>
          <Link to="/credit" className={styles["footer-nav"]}>CREDIT</Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
